export type LookupRow = Record<string, unknown> & { _key: string };

export type AssociationTransferModalProps = {
  open: boolean;
  sourceConfigName: string;
  sourceId: string;
  sourceCode: string;
  sourceName: string;
  targetConfigName?: string;
  targetItems: LookupRow[];
  selectedKeys: string[];
  onTransfer: (targetKeys: string[]) => void;
  onClose: () => void;
};

export type TransferItem = {
  key: string;
  title: string;
  description: string;
};

export type AssociationTransferModalViewProps = {
  open: boolean;
  sourceConfigName: string;
  sourceCode: string;
  sourceName: string;
  counterpartLabel: string;
  dataSource: TransferItem[];
  targetKeys: string[];
  onOk: () => void;
  onClose: () => void;
  onTransferChange: (newTargetKeys: React.Key[]) => void;
  filterOption: (inputValue: string, option: TransferItem) => boolean;
};

export const CONFIG_NAMES = {
  COMPONENT_CLASS: 'Component Class',
  SUBSYSTEM: 'Subsystem',
  ASSET_TYPE: 'Asset Type',
  COMPONENT_TYPE: 'Component Type',
} as const;
